import React, {Component} from 'react';
import './IndustryIndividualMoreCard.css';

export default class IndustriesIndustryMoreCard extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="i_industry_more_card_container">
				<div className="i_industry_more_card">
				<div className="i_industry_more_card_img" style={{backgroundImage: `url(${this.props.image})`}}></div>
				<div className="i_industry_more_card_text">
					<div className="i_industry_more_card_title">{this.props.title} </div>
					<div className="i_industry_more_card_description_container">
						<div className="i_industry_more_card_description"><span>{this.props.description1}</span></div>
						{this.props.description2 && <div className="i_industry_more_card_description"><span>{this.props.description2}</span></div>}
						{this.props.description3 && <div className="i_industry_more_card_description"><span>{this.props.description3}</span></div>}
						{this.props.description4 && <div className="i_industry_more_card_description"><span>{this.props.description4}</span></div>}
					</div>
				</div>
				</div>
			</div>
		)
	}
};
